import { render } from "./PageLoader.vue?vue&type=template&id=71f4b870&scoped=true"
const script = {}

import "./PageLoader.vue?vue&type=style&index=0&id=71f4b870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f4b870"]])

export default __exports__